/**
 * Format the error as a string with a different format depending on whether
 * `err` has a `FIELD` property or not
 * @public
 */
export const getErrorFormat = (err) => (err.FIELD ? `${err.FIELD} - ${err.TEXT}` : `${err.TEXT}`);
